"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _RegionSettingsComponent = _interopRequireDefault(require("./RegionSettingsComponent"));
var _regionFormActions = require("../../../../../redux/actions/regionFormActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var RegionSettingsContainer = (0, _reactRedux.connect)(undefined, {
  setUserRegionConfig: _regionFormActions.setUserRegionConfig
})(_RegionSettingsComponent["default"]);
var _default = exports["default"] = RegionSettingsContainer;